import { SET_ACCESS_TOKEN, SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOADING, SET_STATUS, CLEAR_DATA } from "./constants";
import JWT from '@/utils/jwt'

export default {
  [SET_LOADING](state, value) {
    state.isLoading = value;
  },
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_ACCESS_TOKEN](state, data) {
    JWT.setAccessToken(data.access_token, data.expire_at)
    JWT.setRefreshToken(data.access_token)
  },
  [SET_AUTH](state, user) {
    state.isLoggedIn = true;
    state.user = user;
    state.error = null;
  },
  [PURGE_AUTH](state) {
    state.isLoggedIn = false;
    state.user = {};
    state.error = null;
  },
  [SET_STATUS](state, status) {
    state.status = status;
  },
  [CLEAR_DATA](state) {
    state.isLoggedIn = false
    state.user = {}
    state.status = null
    state.error = null
    state.isLoading = false
  }
};